import App from './App'
import { mountClient } from '@gjl/site-kit'
import { initAnalytics } from './lib/analytics'
import './index.css'

// Google Analytics 4 (no-op until prod / VITE_GA_ID). Fairmeadow keeps its own
// inlined GA module rather than site-kit's, so mountClient's analytics is off
// below — enabling both would double-count every pageview.
initAnalytics()

// Prerendered HTML -> hydrate; empty root (dev) -> fresh render. mountClient
// wraps StrictMode + BrowserRouter + ScrollReset and picks hydrate vs render
// automatically, matching the studio site.
//
// The per-route pageview tracker that used to live here moved INTO App: it calls
// useLocation, so it needs router context, and mountClient owns the router now.
mountClient(App, { analytics: false })
